import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ApiError, AuthProvider } from '@shop/api-client'
import App from './App'
import './index.css'

/**
 * مدخلُ نقطة البيع.
 *
 * <b>ولا موجّهَ مساراتٍ هنا — وهذا يبقى كما كان</b>: الصندوقُ شاشةٌ واحدةٌ
 * وأوراقٌ تعلوها، ولا عنوانَ يُشارَك ولا زرَّ رجوعٍ يُستعمل. وموجّهٌ يُشحن
 * لمسارٍ واحدٍ يُبطئ أوّلَ فتحٍ بلا مقابل.
 *
 * <b>ومخزنُ الاستعلامات دخل مع شاشة البيع</b> — كما وُعد: البحثُ والورديّةُ
 * واللوحةُ تُقرأ كلُّها، وإعادةُ الطلب عند انقطاع الشبكة سلوكٌ يُكتب مرّةً.
 *
 * ⚠ <b>و`staleTime` قصيرٌ هنا لا ٣٠ ثانيةً كالإدارة</b>: رصيدُ صنفٍ يتغيّر مع
 *   كلّ بيعةٍ في المحلّ، وصندوقٌ يعرض رصيدًا عمرُه نصفُ دقيقةٍ يبيع ما نفد.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 3_000,
      refetchOnWindowFocus: false,

      // ‏401 و403 و404 جوابٌ نهائيٌّ من الخادم — وإعادتُها تؤخّر الرسالةَ
      // ثلاثَ مرّاتٍ أمام زبونٍ ينتظر.
      retry: (attempt, error) =>
        !(error instanceof ApiError && error.status < 500) && attempt < 2,
    },
  },
})

// ⚠ **عاملُ الخدمة يحفظ الشاشاتِ نفسَها** (`0052`): الصندوقُ يُفتح والنت مقطوع
//   من نسخةٍ على الجهاز، ثمّ يبيع من نسخة الأصناف. وفي البناء وحدَه — خادمُ
//   التطوير يتغيّر في كلّ حفظ، ونسخةٌ محفوظةٌ منه تُضلّل من يطوّر.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined)
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider offlineCapable>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
